/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentLogId } from "../../commons/types/AgentLogId";
import { AgentId } from "../../commons/types/AgentId";
import { EventId } from "../../commons/types/EventId";
export const AgentLog = core.serialization.object({
    id: AgentLogId,
    agentId: AgentId,
    eventId: EventId,
    success: core.serialization.boolean(),
    createdAt: core.serialization.string(),
    completedAt: core.serialization.string(),
    log: core.serialization.string().optional(),
    queueLag: core.serialization.number().optional(),
    namespaces: core.serialization.list(core.serialization.string()).optional(),
    context: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    topic: core.serialization.string().optional(),
    duration: core.serialization.number().optional(),
    memoryUsage: core.serialization.number().optional(),
    requestTime: core.serialization.number().optional(),
    requestCount: core.serialization.number().optional(),
    bytesReceived: core.serialization.number().optional(),
    bytesSent: core.serialization.number().optional(),
});
